import React, { useContext, useEffect, useState } from "react";
import Screen from '../components/Screen';
import { getCDNImage } from '../globals';
import { i18nValue, formatDate, calculateHoursUntil, mergeHotelAndCheckinPlaceholders } from '../functions';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import Carousel from 'react-bootstrap/Carousel'
import SubPagesList from "../components/SubPagesList";
import { isBelAir, isOffgrid } from "../components/CheckIn/hotelConditions";
import { CheckInContext } from "../context/checkin";
import { T } from "react-translator-component";
import { NavLink, useLocation } from 'react-router-dom';
import { useHourDisabled } from "../hooks/useHourDisabled";
import SectionBlocksRenderer from "../components/Sections/SectionBlocksRenderer";

const Generic = (props) => {
  const { pathname } = useLocation();
  const { data: { id: hotelId }, sectionsByCode, placeholders, getUrlPath } = useContext(HotelContext);
  const { language } = useContext(UserContext);
  const { data: checkIn } = useContext(CheckInContext);
  const { validateHourDisabled } = useHourDisabled(props.section);

  const [buttonMenu, setButtonMenu] = useState(null);
  const [showCoverHourDisabled, setShowCoverHourDisabled] = useState('');

  const customPlaceholders = (data, key, lang, placeholders = null) => {

    const arrPlaceHolders = mergeHotelAndCheckinPlaceholders(placeholders, checkIn?.placeholders);
    let regex = null;
    let customKey = null;
    let value = null;
    let textValue = '';
    if (arrPlaceHolders) {

      if (isOffgrid(hotelId)) {

        customKey = 'CUSTOM-ARRIVAL-INFO';
        value = arrPlaceHolders[customKey];
        if (value) {
          const today = formatDate(new Date());
          textValue = value['out-period'][lang];
          if (!textValue) {
            textValue = value['out-period']['en-US'];
          }

          // Cambio a 24hs antes
          // if (checkIn?.inStay || (checkIn?.dateStart == today)) {
          if (checkIn?.reservation?.arrival) {
            const hours = calculateHoursUntil(checkIn.reservation.arrival);
            console.log('5feb - checkIn.reservation.arrival', checkIn.reservation.arrival);
            console.log('5feb - hours to arrive', hours);
            console.log('5feb - checkIn?.inStay', checkIn?.inStay);
            if (checkIn?.inStay || (hours <= 48)) {
              textValue = value['in-period'][lang];
              console.log('5feb - textValue', textValue);
              if (!textValue) {
                textValue = value['in-period']['en-US'];
              }
            }
          }

          arrPlaceHolders[customKey] = textValue;
        }

        customKey = 'CUSTOM-ARRIVAL-MODE-INFO';
        value = arrPlaceHolders[customKey];
        console.log('9090', value);
        if (value) {
          textValue = '';
          Object.keys(value).map((el, idx) => {
            console.log('9090', el);
            let itemText = value[el][lang];
            console.log('9090 1', itemText);
            if (!itemText) {
              itemText = value[el]['en-US'];
            }
            if (itemText) {
              textValue += itemText;
            }
          });
          arrPlaceHolders[customKey] = textValue;
          console.log('9090', textValue);
        }

      }

    }

    return i18nValue(data, key, lang, arrPlaceHolders);
  }

  // useEffect(() => {

  //   //TODO_G: Cambiar por PH link (Botones a cartas)
  //   if (props?.section === "spa") {
  //     if (isBelAir(hotelId)) {
  //       setButtonMenu({
  //         title: T("spa.Carta_Tratamientos"),
  //         id: "564e732e-2be9-47a4-93e4-fdc69713ff84"
  //       });
  //     }
  //   }

  // }, []);

  useEffect(() => {
    setShowCoverHourDisabled(validateHourDisabled);
  }, [validateHourDisabled]);

  const section = sectionsByCode[props.section];
  const showTitleInsideSection = section?.extras?.showTitleInsideSection !== false;
  const showImageInsideSection = section?.extras?.showImageInsideSection !== false;

  return (
    <Screen
      section={props.section}
      headerTranslucid={true}
      title={i18nValue(section, 'title', language)}
    >
      {showImageInsideSection && section.image && (
        <div className="header-detail-with-image">
          <img
            className="d-block w-100"
            src={getCDNImage(section.image)}
            style={{ objectFit: 'cover' }}
          />
        </div>
      )}

      {showTitleInsideSection && (
        <h5 className="page-detail-title mb-0">{i18nValue(section, 'title', language)}</h5>
      )}
      <p className="page-detail-description" dangerouslySetInnerHTML={{ __html: customPlaceholders(section, 'desc', language, placeholders) }} ></p>
      {
        showCoverHourDisabled
          ?
          <div className="cover-hour-disabled">
            <p>{T(showCoverHourDisabled)}</p>
          </div>
          :
          <>
              <SectionBlocksRenderer
                section={section}
                language={language}
                sectionsByCode={sectionsByCode}
                getUrlPath={getUrlPath}
              />
            {section.pages && <SubPagesList
              data={section.pages}
              language={language}
            />}


            {section?.extras?.foodMenuIds && <>
              {section?.extras?.foodMenuIds.map(buttonMenu => {
                return (
                    <div className="mb-3">
                      <NavLink
                        to={{ pathname: `../menu/${buttonMenu.value}`, id: buttonMenu.value }}
                        state={{ from: pathname }}
                        className="mb-2 d-block w-100 text-center"
                        style={{ color: '#555', border: "1px solid #CCC", textTransform: 'uppercase', height: 50, backgroundColor: "#EEE", lineHeight: "50px", fontWeight: "bold", borderRadius: 8 }}
                      >
                        {i18nValue(buttonMenu, 'customTitle', language)}
                      </NavLink>
                    </div>
                )
              })}
            </>
            }

            {buttonMenu && (
              <div>
                <div className="mb-3">
                  <NavLink
                    to={{ pathname: `../menu/${buttonMenu.id}`, id: buttonMenu.id }}
                    state={{ from: pathname }}
                    className="mb-2 d-block w-100 text-center"
                    style={{ color: '#555', border: "1px solid #CCC", textTransform: 'uppercase', height: 50, backgroundColor: "#EEE", lineHeight: "50px", fontWeight: "bold", borderRadius: 8 }}
                  >
                    {/* {i18nValue(menu, 'name', language)} */}
                    {buttonMenu.title}
                  </NavLink>
                </div>
              </div>
            )}

          </>
      }
    </Screen>
  );
}

export default Generic;